<template>
  <consulta ref="modal" :columns="columns" :process="process" id="consultar-indicador"
            :titulo="`Consultar ${title}`" :mlAuto="!marcados.length"
            :exportar="exportar"
            :custom-actions="actions">

    <template #cabecalho>

      <li class="list-inline-item" v-if="multiplos">
        <a @click.prevent="selecionarTodos()" title="Selecionar Todos" class="icon">
          <i class="fal fa-check-circle"></i>
        </a>
      </li>

      <li class="list-inline-item" v-if="multiplos">
        <a @click.prevent="selecionarTodos(true)" title="Limpar Seleção" class="icon">
          <i class="fal fa-circle"></i>
        </a>
      </li>

    </template>

    <template #filtros>

      <div class="w-100"></div>

      <filtrar-consulta class="w-100" :options="opcoesConsulta" :dto="filtros">
        <template #custom="{item}">
          <template v-if="item.id == 'envolvido_nome'">
            <v-input type="v-multi-select"
                     @change="changePapel"
                     @click="changePapel"
                     v-model="filtros.envolvidoPapel" :options="options.tiposPapeis"  class="col-auto"/>
          </template>
        </template>
      </filtrar-consulta>

    </template>

    <template #row="{ row }">

      <tr>

        <td width="50px" class="text-center" v-if="multiplos">
          <input :id="`check-${row.id}`" class="form-check-input" @click="selectRegistro(row)"
                 style="margin: -5px 0 0 -6px;position: relative;" type="checkbox" v-model="row.selecionado">
        </td>

        <td width="50px" class="text-center">
          <a href class="icon" @click.prevent.stop="detalhes(row.id)">
             <i class="fal fa-landmark"></i>
          </a>
        </td>

        <td width="140px" class="pointer icon" @click="select(row)">
          <a>{{ row.codigo | inteiro }}{{row.livroLetra ? `-${row.livroLetra}` : ''}}</a>
        </td>
        <template v-if="status !== 'PENDENTE'">
          <td width="120px">{{ row.abertura | datahora }}</td>
          <td width="120px">{{ row.encerramento | datahora }}</td>
        </template>

        <td width="120px" class="text-capitalize">{{ row.status.toLowerCase() }}</td>
        <td width="120px">{{ row.tipoRegistro }}</td>

      </tr>

    </template>
    <template #footer>

      <v-button v-if="marcados.length > 0" class="btn btn-outline-primary mr-2 ml-auto" :run="select" :params="[marcados]">
        Adicionar
      </v-button>

    </template>

  </consulta>
</template>

<script>
  import AnexoBusiness from "@/business/AnexoBusiness.js";
  import FrontBusiness from "@/business/FrontBusiness.js";
  import RegistroPJBusiness from "@/business/indicadores/RegistroPJBusiness.js";
  import FiltrarConsulta from "@/components/Consultas/components/FiltrarConsulta.vue";
  import Consulta from "@/components/Consultas/Consulta.vue";
  import ModalFichaAntiga from "@/components/ModalFichaAntiga.vue";
  import DetalhesRegistroPJ from "@/components/RegistroPJ/Detalhes/DetalhesRegistroPJ.vue";
  import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness.js";
  import Utils from "@/commons/Utils.js";
  import TipoServicoBusiness from "@/business/crud/TipoServicoBusiness.js";
  import ConsultarRegistroPJ from "@/components/RegistroPJ/ConsultarRegistroPJ.vue";
  import ConsultarRelatorio from "@/components/Consultas/ConsultarRelatorio.vue";
  import ArquivoRelatorioBusiness from "@/business/relatorios/ArquivoRelatorioBusiness";
  import UsuarioBusiness from "@/business/crud/UsuarioBusiness";

export default {
    name: "ConsultarRegistroPJ",
    components: {FiltrarConsulta, Consulta},
    props: {
      multiplos : {type : Boolean, default : false},
      seleciona : {type : Boolean, default : true},
      status : String, // PENTENDE, ABERTA, NULL
      registro: String
    },
    data() {

      return {
        buscar : 'REGISTRO_PJ',
        indicador_real: '',
        mode: 'novo',
        opcoesConsulta: RegistroPJBusiness.camposConsulta().filter(i => {
          return !i.status || (i.status && !this.status) || (this.status && i.status && (i.status).includes(this.status))
        }).filter(l => l.id != 'envolvido_papel'),
        filtros : {
          filtros: [],
          codigo: null,
          status : this.status,
          envolvidoDocumento: null,
          envolvidoNome: null,
          digitalizacao: '',
          matricula: null
        },
        options: {
          tiposPessoa: IndicadorPessoalBusiness.getTiposPessoa(),
          todosTiposPapeis: [{id:'TODOS', nome:'Todos os papéis'}],
          tiposPapeis: this.todosTiposPapeis,
          tiposAto: [],
          tiposDigitalizacao: AnexoBusiness.tiposDigitalizacao()
        },
        marcados: [],
        listas:{
          livros: [
            {id: 'MATRICULA', nome: 'Matrícula'},
            {id: 'PRE_MATRICULA', nome: 'Pré-Matrícula'}
          ]
        },
      }
    },

    computed:{
      auditor() {
        return this.$root.isAuditorOnly;
      },

      title(){
        return FrontBusiness.nomearFicha({livro : 'REGISTRO_PJ', status : this.status}, false);
      },
      columns(){
        let columns = [
          {label: '', show: this.multiplos, field: 'selecionar', headerClass: 'column__botao', sortable: false, name: 'selecionar'},
          {label: '', field: 'id', headerClass: 'column__botao', sortable: false, name: 'id'},
          {label: this.title, field: 'i.codigo', headerClass: 'column__codigo_doc', name: 'codigo'},
        ]
        if(this.status !== 'PENDENTE'){
          columns.push({label: 'Abertura', field: 'i.abertura', name: 'abertura', minWidth:'200px'},
            {label: 'Encerramento', field: 'i.encerramento', name: 'encerramento', minWidth:'200px'});
        }

        columns.push({label: 'Situação', field: 'i.status', headerClass: 'column__status', name: 'status'},
          {label: 'Tipo Registro', field: 'i.tipo_registro', headerClass: 'column__tipo_registro', name: 'tipoRegistro'});

        return columns;
      },

      livroSelecionado() {
        return this.buscar === 'PRE_MATRICULA' ? 'MATRICULA' : this.buscar;
      },

      statusSelecionado() {
        return this.buscar === 'PRE_MATRICULA' ? 'PENDENTE' : 'ABERTA';
      },

      exportar(){
        let forms = {
          direction:"desc",
          sort:"i.codigo",
          preMatricula: this.status == 'PENDENTE',
          filtros:Utils.clone([...this.filtros?.filtros].filter(e => e.id))
        };

        let envolvido_nome = forms.filtros.find(f => f.id == 'envolvido_nome');

        if(envolvido_nome) {
          envolvido_nome.value = {
            envolvido_nome: envolvido_nome.value,
            envolvido_papel: this.filtros.envolvidoPapel === "TODOS" ? null : this.filtros.envolvidoPapel
          }
        }

        return this.mode === 'novo' && !this.auditor ? {id: "EXPORTAR_REGISTRO_PJ", forms, extensao: "XLSX"} : null;
      },

      actions() {
        let actions = [];
        if (this.auditor) return actions;
        if (this.status !== 'PENDENTE') {
          actions.push({
            ordem: 4,
            class: 'at-options',
            icon: 'far fa-plus-square mr-1',
            label: 'Cadastrar Registro Antigo',
            action: this.cadastrarAntiga
          });
          actions.push({
            ordem: 8,
            class: 'at-options',
            icon: 'far fa-file-search mr-1',
            label: 'Consultar pré-registro de título',
            action: this.consultarPreRegistro
          });
        }
        return  Utils.orderBy(actions, 'ordem');
      }
    },

    mounted() {

      let papeis = this.$root.papeis;
      this.options.tiposPapeis = this.options.todosTiposPapeis.concat(papeis);
      this.$set(this.filtros, 'envolvidoPapel', [this.options.tiposPapeis[0].id]);

      //Define o filtro 'Tipo de Regsitro' como default ou não pelo componente de buscarFichas
      if(this.registro != null){
        this.filtros.filtros = [{id: "tipo_registro",type: null,value: this.registro, hiddenActions: true}]
      }

      this.load();

    },

    methods:{

      async load() {
        this.options.tiposAto = await TipoServicoBusiness.getByDominioLivroSimples('PROTOCOLO_RCPJ', 'REGISTRO_PJ');
        this.opcoesConsulta.push({unificado: true, livro: null, status: ['ABERTA','CANCELADA','ENCERRADA'],id: 'usuario_alteracao_manual', nome: 'Usuário da Alteração Manual', type: 'list', options: await UsuarioBusiness.getAllSimpleList()},)
      },

      close(){
        FrontBusiness.closeModal();
      },

      select(registro){
        if (this.seleciona) {
          FrontBusiness.closeModal(registro);
        } else {
          this.detalhes(registro?.id)
        }
      },

      async process(sort_by, sort_dir, page_length, page_number){

        let filtros = Utils.clone([...this.filtros?.filtros].filter(e => e.id));

        let indicador_real_id = filtros.find(e => e.id === 'indicador_real_id');
        if (indicador_real_id) {
          indicador_real_id.value = this.filtros.indicador_real;
        }

        let preMatricula = this.status == 'PENDENTE';

        let envolvido_nome = filtros.find(f => f.id == 'envolvido_nome');

        if(envolvido_nome) {
          envolvido_nome.value = {
            envolvido_nome: envolvido_nome.value,
            envolvido_papel: this.filtros.envolvidoPapel?.filter(c => c !== 'TODOS')
          }
        }
        return RegistroPJBusiness.paginationV2(sort_by, sort_dir, page_number, page_length, {filtros, preMatricula})
          .then(result => ({rows: result.pagina, total: result.quantidade}));

      },

      detalhes(id){
        FrontBusiness.openModal(DetalhesRegistroPJ, {id});
      },

      tipoRegistro(valor){
        return FrontBusiness.getLabel(valor, RegistroPJBusiness.getTipos());
      },

      formatarCodigo : FrontBusiness.formatarCodigo,

      selecionar(item, nomeFiltro){
        this.$nextTick(() => {
           this.filtros[nomeFiltro] = item ? item.indicadorPessoalId : null;
        });
      },

      remover(idx, lista) {
        this.$nextTick(() => {
          this.filtros[lista].splice(idx, 1);
        });
      },

      selectRegistro(ficha) {
        let index = this.marcados.findIndex(e => e.id === ficha.id);
        if (index >= 0) {
          this.marcados.splice(index, 1)
        } else {
          this.marcados.push(ficha)
        }
      },

      selecionarTodos(limpar = false) {
        this.marcados = [];
        this.$refs?.modal?.$refs?.paginator?.rows.forEach(r => {
          let input = document.getElementById(`check-${r.id}`)
          input.checked = !limpar;
          if (!limpar) this.marcados.push(r)
        })
      },

      async cadastrarAntiga(){
        const indicador = await FrontBusiness.openModal(ModalFichaAntiga, {livro: 'REGISTRO_PJ'});
        if(indicador){
          FrontBusiness.openModal(DetalhesRegistroPJ, {id: indicador});
        }
      },

      consultarPreRegistro() {
        FrontBusiness.closeModal();
        FrontBusiness.openModal(ConsultarRegistroPJ, {status : 'PENDENTE', seleciona: false}, 1300, true);
      },

      async exportarRelatorio(){
        let forms = {
          direction:"desc",
          sort:"i.codigo",
          preMatricula: this.status == 'PENDENTE',
          filtros:Utils.clone([...this.filtros?.filtros].filter(e => e.id))
        };

        let envolvido_nome = forms.filtros.find(f => f.id == 'envolvido_nome');

        if(envolvido_nome) {
          envolvido_nome.value = {
            envolvido_nome: envolvido_nome.value,
            envolvido_papel: this.filtros.envolvidoPapel === "TODOS" ? null : this.filtros.envolvidoPapel
          }
        }

        await ArquivoRelatorioBusiness.save("EXPORTAR_REGISTRO_PJ",forms,"XLSX")
          .then(()=>{
            FrontBusiness.showSuccess('',"Relatório adicionado à fila de processo.");
          }).catch(e =>{
            FrontBusiness.showError('Erro ao adicionar relatório a fila de processo!', e?.message);
          })

      },

      openRelatorio(){
        FrontBusiness.openModal(ConsultarRelatorio);
      },

      changePapel(e) {
        let isTodos = !e.length || e[e.length - 1] === 'TODOS';
        this.$set(this.filtros, 'envolvidoPapel', isTodos ? ['TODOS'] : this.filtros.envolvidoPapel.filter(c => c !== 'TODOS'));
        this.$forceUpdate();
      },

      selecionarFichas(nomeFiltro, item, add, x){

        this.$nextTick(() => {
          nomeFiltro = nomeFiltro || x;
          this.filtros[nomeFiltro] = item[0] ? item[0].id : null;
          if (nomeFiltro === 'indicador_real') {
            this[nomeFiltro] = item[0];
          } else {
            this[nomeFiltro] = item[0] ? String(item[0].codigo) + (item[0]?.livroLetra || '') : null;
          }

          if (add && item[0]) {
            this.executeLoad();
          }

        });
      },

    }
  }
</script>
